<template>
  <div class="Webber">
    <ol>
      <li>제한시간 안에 거미줄을 가장 많이 모으는 사람이 승리합니다</li>
      <li>거미줄을 모으는 도중 죽으면 탈락입니다</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Webber'
}
</script>


// WEBPACK FOOTER //
// src/components/Mission/Webber.vue